module.exports = __webpack_public_path__ + "static/media/pendingSale.c14b2541.svg";